import { render, staticRenderFns } from "./doktambahan.vue?vue&type=template&id=9f11d436"
import script from "./doktambahan.vue?vue&type=script&lang=js"
export * from "./doktambahan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports